const updateEmailStyles = {
    container: `flex flex-col gap-[12px] items-center justify-center rounded-[8px] bg-white p-[25px] w-full text-black relative
    screen-500:w-[430px]
`,
    heading: `text-[18px] capitalize font-Suisse w-full`,
    closeButton: `absolute top-[1px] right-2`,
    newValueContainer: `relative w-full flex flex-col gap-1`,
    popup_img: `max-w-[40px] w-full h-auto`,
    img_heading: `w-full flex items-end gap-[13px]`,
    formContainer: `flex flex-col items-center justify-center gap-6 w-full`,
    resendOtp: `text-right text-primaryHeading text-[10px]`,
    button: `w-full`,
    otpContainer: `flex flex-col gap-6 w-full`,
    afterOtpreceivedContainer: `flex justify-between`,
    spamNote: `text-gray-500 text-[10px]`,
}

export { updateEmailStyles }